import React, { useState } from 'react';
import { FiSend, FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import { requestAPI } from '../../api/services';
import { useTranslation } from 'react-i18next';

const ContactPage = () => {
  const [form, setForm] = useState({ fullName: '', phone: '', text: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.fullName || !form.phone || !form.text) {
      setError(t('auth.fill_fields'));
      return;
    }
    setLoading(true);
    setError('');
    try {
      await requestAPI.add(form);
      setSuccess(true);
      setForm({ fullName: '', phone: '', text: '' });
      setTimeout(() => setSuccess(false), 4000);
    } catch (err) {
      setError(t('common.operation_failed'));
    } finally {
      setLoading(false);
    }
  };

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <>
      <div className="page-header">
        <div className="container">
          <img src="/illustrations/contact.png" alt="Contact" className="page-header-illustration" />
          <span className="section-label">{t('contact.get_in_touch')}</span>
          <h1>{t('contact.title')}</h1>
          <p>{t('contact.subtitle')}</p>
        </div>
      </div>

      <section className="section" style={{ paddingTop: 32 }}>
        <div className="container">
          <div className="contact-section">
            <div>
              <h2 style={{ fontSize: '1.3rem', fontWeight: 800, marginBottom: 8 }}>{t('contact.send_message')}</h2>
              <p style={{ color: 'var(--text-secondary)', marginBottom: 22, fontSize: '0.92rem' }}>
                {t('contact.form_desc')}
              </p>
              <div className="contact-info-card">
                <div className="contact-info-icon"><FiMapPin /></div>
                <div>
                  <h4 style={{ fontWeight: 600, marginBottom: 3 }}>{t('contact.address')}</h4>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>{t('contact.address_val')}</p>
                </div>
              </div>
              <div className="contact-info-card">
                <div className="contact-info-icon"><FiPhone /></div>
                <div>
                  <h4 style={{ fontWeight: 600, marginBottom: 3 }}>{t('contact.phone')}</h4>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>+998 90 123 45 67</p>
                </div>
              </div>
              <div className="contact-info-card">
                <div className="contact-info-icon"><FiMail /></div>
                <div>
                  <h4 style={{ fontWeight: 600, marginBottom: 3 }}>{t('contact.email')}</h4>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.85rem' }}>info@uzsport.uz</p>
                </div>
              </div>
            </div>

            <form onSubmit={handleSubmit} style={{ background: '#fff', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: 28 }}>
              {error && <div className="auth-error" style={{ marginBottom: 14 }}>{error}</div>}
              {success && <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 'var(--radius)', padding: '10px 14px', color: 'var(--accent)', fontSize: '0.85rem', textAlign: 'center', marginBottom: 14 }}>{t('contact.success')}</div>}
              <div className="form-group" style={{ marginBottom: 14 }}>
                <label>{t('fields.fullName')}</label>
                <input className="form-input" name="fullName" value={form.fullName} onChange={onChange} placeholder={t('contact.full_name_placeholder')} />
              </div>
              <div className="form-group" style={{ marginBottom: 14 }}>
                <label>{t('auth.phone')}</label>
                <input className="form-input" name="phone" value={form.phone} onChange={onChange} placeholder="+998 90 123 45 67" />
              </div>
              <div className="form-group" style={{ marginBottom: 20 }}>
                <label>{t('fields.comment')}</label>
                <textarea className="form-input" name="text" value={form.text} onChange={onChange} placeholder={t('contact.message_placeholder')} rows={5} />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
                {loading ? t('contact.sending') : <><FiSend /> {t('contact.btn_send')}</>}
              </button>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
